import { render } from "./AddPersonForm.vue?vue&type=template&id=2775fae4&scoped=true"
import script from "./AddPersonForm.vue?vue&type=script&lang=js"
export * from "./AddPersonForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AddPersonForm.vue?vue&type=style&index=1&id=2775fae4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2775fae4"]])

export default __exports__